import React, { useMemo } from 'react'
import Table from '../../../../../../components/table/Table'
import { courses } from '../../../billing/components/dummyData';

const CoursesCompletion = () => {

    const courses = JSON.parse(sessionStorage.getItem('active-learner'))?.courses

      const columns = useMemo(
        () => [
          {
            title: "ID",
            selector: null,
            key: "id",
            render: ({ index }) =>
              index +
              1 
              
          },
          {
            title: "Title",
            selector: "courseName",
            key: "courseName",
    
            render: ({ item }) => (
              <span> {item}</span>
            
            ),
          },
          {
            title: "Overrall Score",
            selector: "overallScore",
            key: "overallScore",
    
            render: ({ item }) => (
              <span> {item}</span>
            
            ),
          },
          {
            title: "Status",
            selector: "status",
            key: "status",
    
            render: ({ item }) => (
                <span className={
                    `${item === 'in progress' ? 'block text-primary rounded-full w-[80px] text-center py-1 border border-primary'
                     : 'text-primary-green block w-[80px] text-center py-1 border border-primary-green rounded-full' 
                   }`}>
                   {item}
                </span>
            
            ),
          },
        ],
        []
      );

    const tableProps = {
        isLoading: false,
        columns,
        data: courses || [],
        };

  return (
    <div>
        <Table
            {...tableProps}
            style={{
              overflowX: "auto",
            }}
            headerClassName={"border-t bg-gray-100"}
          />
    </div>
  )
}

export default CoursesCompletion